var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard db-",attrs:{"id":"app"}},[_c('div',{staticClass:"mobile-flag d-block d-sm-none w-100"}),(_vm.alert)?_c('b-alert',{attrs:{"show":_vm.showAlert,"variant":_vm.alertType,"dismissible":"","fade":""},on:{"dismissed":_vm.clearAlert}},[_vm._v(_vm._s(_vm.alert)+" ")]):_vm._e(),_c('background-process'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }